import { Picture } from "@/components/ui/Picture";

/**
 * Logo lockup.
 *
 * The supplied file is a 250x116px raster of emblem + wordmark, which is too
 * low-resolution to sit crisply in a header. Only the emblem is used from it
 * (extracted, squared and upscaled once to 512px); the wordmark is set in the
 * site's own type. That keeps the mark authentic, stays sharp at any density,
 * and reads far cleaner than the original lockup.
 */
export function Logo({ tone = "dark" }: { tone?: "dark" | "light" }) {
  const light = tone === "light";

  return (
    <span className="flex items-center gap-2.5">
      <Picture
        asset={light ? "brand/emblem-white" : "brand/emblem"}
        alt=""
        priority
        className="h-9 w-9 shrink-0 md:h-10 md:w-10"
      />
      <span className="flex flex-col leading-none">
        <span
          className={`font-sans text-[0.9375rem] font-bold leading-none tracking-[0.02em] ${
            light ? "text-white" : "text-midnight"
          }`}
        >
          HIMSHIKHARA
        </span>
        <span
          className={`mt-1 text-[0.5625rem] font-semibold uppercase leading-none tracking-[0.16em] ${
            light ? "text-white/65" : "text-muted"
          }`}
        >
          Socio-Cultural Society
        </span>
      </span>
    </span>
  );
}
